@if (user(); as user) {
  @if (organization(); as organization) {
    <div>
      <h5 class="contract-partner-info-headline">
        {{ 'booking.form.headline.contact' | transloco }}
      </h5>
      <ui-booking-info-list>
        <ui-booking-info-list-item>
          {{ organization.name }}
        </ui-booking-info-list-item>
        <ui-booking-info-list-item>
          {{ organization.address.street }}
          {{ organization.address.streetNumber }}
        </ui-booking-info-list-item>
        <ui-booking-info-list-item>
          {{ organization.address.zipCode }}
          {{ organization.address.city }}
        </ui-booking-info-list-item>
      </ui-booking-info-list>
    </div>
    <div>
      <h5 class="contract-partner-info-headline">
        {{ 'booking.form.headline.billingContact' | transloco }}
      </h5>
      <ui-booking-info-list>
        <ui-booking-info-list-item>
          {{ 'general.salutation.' + user.salutation | transloco }}
          {{ user.firstname }} {{ user.lastname }}
        </ui-booking-info-list-item>
        <ui-booking-info-list-item icon="m_message-small">
          {{ user.email }}
        </ui-booking-info-list-item>
        @if (user.position) {
          <ui-booking-info-list-item icon="m_profession-small">
            {{ user.position }}
          </ui-booking-info-list-item>
        }
        @if (user.phone) {
          <ui-booking-info-list-item icon="m_phone-small">
            {{ user.phone }}
          </ui-booking-info-list-item>
        }
      </ui-booking-info-list>
    </div>
    <div>
      <h5 class="contract-partner-info-headline">
        {{ 'booking.form.headline.billingAddress' | transloco }}
      </h5>
      <ui-booking-info-list>
        <ui-booking-info-list-item>
          {{ organization.name }}
        </ui-booking-info-list-item>
        <ui-booking-info-list-item>
          {{ organization.address.street }}
          {{ organization.address.streetNumber }}
        </ui-booking-info-list-item>
        <ui-booking-info-list-item>
          {{ organization.address.zipCode }}
          {{ organization.address.city }}
        </ui-booking-info-list-item>
      </ui-booking-info-list>
    </div>
  }
}
